import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {FilterModelDto} from "../../models/filter.model";
import {Subscription} from "rxjs";
import {FilterSettingService} from "../../services/filter-setting.service";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {StringToDateService} from "../../services/string-to-date.service";

@Component({
  selector: 'app-form-custom-datepicker',
  templateUrl: './form-custom-datepicker.component.html',
  styleUrls: ['./form-custom-datepicker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FormCustomDatepickerComponent),
    multi: true
  }]
})
export class FormCustomDatepickerComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() title = ''
  @Input() errorText = ''
  @Input() isDisable = false;
  @Input() filter!: FilterModelDto;
  @Input() date: Date | undefined;
  @Input() isFull = false;
  @Input() horizontalPosition: 'bottom' | 'top' | 'center' | 'semi-top' = 'bottom';
  @Input() verticalPosition: 'left' | 'right' = 'left';
  @Output() setData: EventEmitter<Date> = new EventEmitter<Date>();

  onChange = (value: any) => {}
  onTouched = (value: any) => {}

  mount!: number;
  year!: number;
  dayWeek: any;

  countMountDays = [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  daysArray: number[] = [];

  selectedDate: Date | undefined;
  selectedHours = '00';
  selectedMinute = '00';
  selectedSecond = '00';

  isOpenDatePicker = false;

  subs: Subscription[] = [];

  @HostListener('document:click', ['$event'])
  clickOut(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeDatePicker()
    }
  }

  constructor(
    private eRef: ElementRef,
    private filterSettingService: FilterSettingService,
    private stringToDateService: StringToDateService
  ) {}

  ngOnInit() {
    this.initCalendar();
    this.resetListener();
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  writeValue(value: any) {
    if (value) {
      this.date = this.stringToDateService.toDate(value)
      setTimeout(() => {
        this.onChange(this.date)
      }, 0)
    } else {
      this.date = undefined
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn
  }

  initCalendar() {
    const date = new Date();
    this.year = date.getFullYear();
    this.mount = date.getMonth();
    this.getFistDayWeek();
  }

  resetListener() {
    this.subs.push(
      this.filterSettingService.filterItemReset$.subscribe({
        next: (res) => {
          if (this.filter.fieldName === res.fieldName) {
            this.resetCalendar();
          }
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterAllReset$.subscribe({
        next: () => {
          this.resetCalendar();
        },
      })
    );
  }

  resetCalendar() {
    this.date = this.selectedDate = undefined;
    this.initCalendar();
  }

  getFistDayWeek() {
    this.daysArray = [];
    const date = new Date(this.year, this.mount, 1);
    this.dayWeek = date.getDay();

    // Опеределяем высокосный год
    let days: number = this.countMountDays[this.mount];
    if (days === 0) {
      if (
        (this.year % 4 == 0 && this.year % 100 != 0) ||
        this.year % 400 == 0
      ) {
        days = 29;
      } else {
        days = 28;
      }
    }

    // Заполняем массив числами месяца
    if (this.dayWeek === 0) {
      for (let i = 0; i < 6; i++) {
        this.daysArray.push(0);
      }
      for (let i = 0; i < days; i++) {
        this.daysArray.push(i + 1);
      }
      return;
    }

    for (let i = 0; i < this.dayWeek - 1; i++) {
      this.daysArray.push(0);
    }

    for (let i = 0; i < days; i++) {
      this.daysArray.push(i + 1);
    }
  }

  nextMount() {
    if (this.mount !== 0) {
      this.mount--;
    } else {
      this.year--;
      this.mount = 11;
    }
    this.getFistDayWeek();
  }

  prevMount() {
    if (this.mount !== 11) {
      this.mount++;
    } else {
      this.year++;
      this.mount = 0;
    }
    this.getFistDayWeek();
  }

  setDay(year: number, mount: number, day: number | undefined) {
    if (day === 0) {
      return;
    }
    this.selectedDate = new Date(
      year,
      mount,
      day,
      +this.selectedHours,
      +this.selectedMinute,
      +this.selectedSecond
    );
  }

  setHours() {
    if (+this.selectedHours > 23) {
      this.selectedHours = '23';
    }
    this.setTime();
  }

  setMinutes() {
    if (+this.selectedMinute > 59) {
      this.selectedMinute = '59';
    }
    this.setTime();
  }

  setSecond() {
    if (+this.selectedSecond > 59) {
      this.selectedSecond = '59';
    }
    this.setTime();
  }

  setTime() {
    if (this.selectedDate) {
      this.setDay(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate()
      );
    }
  }

  selectDateAndTime() {
    this.date = this.selectedDate
    this.onChange(this.date)
    this.closeDatePicker();
  }

  closeDatePicker() {
    if (this.isOpenDatePicker) {
      this.onTouched(null)
    }
    this.isOpenDatePicker = false;
  }

  openDatePicker() {
    if (!this.isDisable) {
      this.isOpenDatePicker = !this.isOpenDatePicker;
    }
  }
}

